import axios, { AxiosRequestConfig } from "axios";
import qs from "qs";
export { AxiosRequestConfig } from "axios";

export enum ContentType {
  FORM_URLENCODED = "application/x-www-form-urlencoded",
  FORM_DATA = "multipart/form-data",
}

declare global {
  interface Window {
    soyoung: {
      uid: string;
    };
    globalData: {
      CSRF_TOKEN: string;
    };
  }
}

/**
 * post 方式的contentType类型
 *
 * @export
 * @enum {number}
 */
axios.defaults.headers.post["Content-Type"] = ContentType.FORM_URLENCODED;

// 拦截器
axios.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === "development") {
      config.baseURL = `/mock`;
    } else {
      config.baseURL = "/";
    }
    const hasCSRF = window?.globalData?.CSRF_TOKEN;
    if (config.data instanceof FormData) {
      config.data.append("sys", "0");
      hasCSRF && config.data.append("CSRF_TOKEN", window.globalData.CSRF_TOKEN);
    } else if (typeof config.data === "object") {
      config.data.sys = 0;
      hasCSRF && (config.data.CSRF_TOKEN = window.globalData.CSRF_TOKEN);
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => Promise.reject(error)
);
/**
 * get 请求
 *
 * @export
 * @param {string} url
 * @param {AxiosRequestConfig} [options]
 * @return {*}  {Promise<any>}
 */
export async function get(
  url: string,
  options?: AxiosRequestConfig
): Promise<any> {
  const { data } = await axios.get(url, options);
  return data;
}

/**
 * post 请求
 *
 * @export
 * @param {string} url
 * @param {{ [propName: string]: any }} [data]
 * @param {AxiosRequestConfig} [options]
 * @return {*}  {Promise<any>}
 */

export async function post(
  url: string,
  data?: { [propName: string]: any },
  options?: AxiosRequestConfig
): Promise<any> {
  const res = await axios.post(url, data, options);
  return res.data;
}

/**
 * 针对于上传类操作
 *
 * @export
 * @param {string} url
 * @param {FormData} data
 * @param {(progressEvent: any) => void} [onUploadProgress]
 * @param {AxiosRequestConfig} [options]
 * @return {*}  {Promise<any>}
 */
export declare type OnUploadProgressHandler = (progressEvent: any) => void;
export async function upload(
  url: string,
  data: FormData,
  onUploadProgress?: OnUploadProgressHandler,
  options?: AxiosRequestConfig
): Promise<any> {
  const res = await axios.post(
    url,
    data,
    Object.assign(options || {}, {
      onUploadProgress,
      headers: {
        "Content-Type": ContentType.FORM_DATA,
      },
    })
  );
  return res.data;
}
